import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Loader from '../_common/Loader'
import _ from 'lodash'

import { fetchChatList, filterChat } from '../../actions'
import ChatList from './ChatList'

export class Chat extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      filter: 'すべて'
    }
  }
  componentDidMount () {
    const params = _.isEmpty(this.props.match.params)
      ? null
      : {
        category: this.props.match.params.category,
        categoryID: this.props.match.params.id
      }
    this.props.fetchChatList(params)
  }

  _handleFlagClick (e) {
    const filter = e.currentTarget.dataset.filter
    this.setState({ filter })

    // const convertFilter = (filter) => {
    //   switch (filter) {
    //     case '対応待ち':
    //       return true
    //     case '返事待ち':
    //       return false
    //     case '対応済':
    //       return undefined
    //     default:
    //       return 'すべて'
    //   }
    // }
    this.props.filterChat(filter)
  }

  _renderLoader () {
    return <Loader key="loader" classname="loader_dot_circle"/>
  }

  _renderChatList () {
    return (
      <div className="chat_main_container">
        <div className="list_header flex justify-between align-center">
          <div className="flag_container flex">
            <div className={this.state.filter === 'すべて' ? 'flag active' : 'flag'} data-filter="すべて" onClick={this._handleFlagClick.bind(this)}>すべて</div>
            <div className={this.state.filter === '対応待ち' ? 'flag active' : 'flag'} data-filter="対応待ち" onClick={this._handleFlagClick.bind(this)}>対応待ち</div>
            <div className={this.state.filter === '返事待ち' ? 'flag active' : 'flag'} data-filter="返事待ち" onClick={this._handleFlagClick.bind(this)}>返事待ち</div>
            <div className={this.state.filter === '対応済' ? 'flag active' : 'flag'} data-filter="対応済" onClick={this._handleFlagClick.bind(this)}>対応済</div>
          </div>
          <div className="result bold">{this.props.chat.resultNumber}件</div>
        </div>
        <ChatList data={this.props.chat.filteredData} />
      </div>
    )
  }

  render () {
    return (
      <section className="chat_list">
        <h4 className="page_title bold">ルーム選択</h4>
        {
          this.props.chat && !this.props.chat.loading
            ? this._renderChatList()
            : this._renderLoader()
        }
      </section>
    )
  }
}

function mapStateToProps ({ chat }) {
  return { chat }
}

export default connect(mapStateToProps, { fetchChatList, filterChat })(Chat)



// WEBPACK FOOTER //
// ./src/components/Chat/index.js